import {ImageSourcePropType} from 'react-native';

export interface IImage {
  sent: ImageSourcePropType;
  microOff: ImageSourcePropType;
  cameraStateOn: ImageSourcePropType;
  cameraStateOff: ImageSourcePropType;
  activeChatMessages: ImageSourcePropType;
  usualChatMessages: ImageSourcePropType;
  activeFaceSmile: ImageSourcePropType;
  usualFaceSmile: ImageSourcePropType;
  microphoneStateOn: ImageSourcePropType;
  microphoneStateOff: ImageSourcePropType;
  activeShare: ImageSourcePropType;
  defaultShare: ImageSourcePropType;
  disconnect: ImageSourcePropType;
  cameraOff: ImageSourcePropType;
  back: ImageSourcePropType;
  heroImageLoginScreen: ImageSourcePropType;
  leftEllipseGradient: ImageSourcePropType;
  rightEllipseGradient: ImageSourcePropType;
  colorfulGoogleLogo: ImageSourcePropType;
  addIcon: ImageSourcePropType;
  calendarIcon: ImageSourcePropType;
  classIcon: ImageSourcePropType;
  clockIcon: ImageSourcePropType;
  deleteIcon: ImageSourcePropType;
  downArrowIcon: ImageSourcePropType;
  languageIcon: ImageSourcePropType;
  subjectIcon: ImageSourcePropType;
  googleIconWhite: ImageSourcePropType;
  signInBackground: ImageSourcePropType;
  homeTabActive: ImageSourcePropType;
  chartsTabActive: ImageSourcePropType;
  profileTabActive: ImageSourcePropType;
  homeTabInactive: ImageSourcePropType;
  chartsTabInactive: ImageSourcePropType;
  profileTabInactive: ImageSourcePropType;
  smallArrowRight: ImageSourcePropType;
  smallArrowDown: ImageSourcePropType;
  arrowLeft: ImageSourcePropType;
  arrowRight: ImageSourcePropType;
  activeUsers: ImageSourcePropType;
  usualUsers: ImageSourcePropType;
  activeRightArrow: ImageSourcePropType;
  activeLeftArrow: ImageSourcePropType;
  defaultLeftArrow: ImageSourcePropType;
  defaultRightArrow: ImageSourcePropType;
  disabledLeftArrow: ImageSourcePropType;
  disabledRightArrow: ImageSourcePropType;
  downArrow: ImageSourcePropType;
  participantsMicroOff: ImageSourcePropType;
  participantsVideoOff: ImageSourcePropType;
  appIcon: ImageSourcePropType;
  profilePhoto: ImageSourcePropType;
  profilePhotoPurple: ImageSourcePropType;
  logout: ImageSourcePropType;
  trash: ImageSourcePropType;
  trashDark: ImageSourcePropType;
  googleIconBlue: ImageSourcePropType;
  pen: ImageSourcePropType;
  whitePen: ImageSourcePropType;
  grayPen: ImageSourcePropType;
  error: ImageSourcePropType;
  cross: ImageSourcePropType;
  crossTransparent: ImageSourcePropType;
  success: ImageSourcePropType;
  symbolHide: ImageSourcePropType;
  symbolShow: ImageSourcePropType;
  dots: ImageSourcePropType;
  charts: ImageSourcePropType;
  meatballMenu: ImageSourcePropType;
}

export const light = {
  sent: require('../assets/images/sent/light/sent.png'),
  microOff: require('../assets/images/microOff/light/microOff.png'),
  cameraStateOn: require('../assets/images/camera/on/light/camera.png'),
  cameraStateOff: require('../assets/images/camera/off/light/camera.png'),
  activeChatMessages: require('../assets/images/chatMessages/active/light/chatMessages.png'),
  usualChatMessages: require('../assets/images/chatMessages/usual/light/chatMessages.png'),
  activeFaceSmile: require('../assets/images/faceSmile/active/light/faceSmile.png'),
  usualFaceSmile: require('../assets/images/faceSmile/usual/light/faceSmile.png'),
  microphoneStateOn: require('../assets/images/microphone/on/light/microphone.png'),
  microphoneStateOff: require('../assets/images/microphone/off/light/microphone.png'),
  activeShare: require('../assets/images/activeShare/light/share.png'),
  defaultShare: require('../assets/images/defaultShare/light/share.png'),
  disconnect: require('../assets/images/disconnect/light/disconnect.png'),
  cameraOff: require('../assets/images/cameraOff/light/cameraOff.png'),
  back: require('../assets/images/back/light/back.png'),
  heroImageLoginScreen: require('../assets/images/loginScreenImages/light/heroImage/heroImage.png'),
  leftEllipseGradient: require('../assets/images/loginScreenImages/light/gradientImage/leftEllipseGradient.png'),
  rightEllipseGradient: require('../assets/images/loginScreenImages/light/gradientImage/rightEllipseGradient.png'),
  colorfulGoogleLogo: require('../assets/images/shared/light/googleIcon/colorfulGoogleIcon.png'),
  addIcon: require('../assets/images/createClassScreenImages/light/addImage/add.png'),
  calendarIcon: require('../assets/images/createClassScreenImages/light/calendarImage/calendar.png'),
  classIcon: require('../assets/images/createClassScreenImages/light/classImage/class.png'),
  clockIcon: require('../assets/images/createClassScreenImages/light/clockImage/clock.png'),
  deleteIcon: require('../assets/images/createClassScreenImages/light/deleteImage/delete.png'),
  downArrowIcon: require('../assets/images/createClassScreenImages/light/downImage/down.png'),
  languageIcon: require('../assets/images/createClassScreenImages/light/languageImage/lang.png'),
  subjectIcon: require('../assets/images/createClassScreenImages/light/subjectImage/subject.png'),
  googleIconWhite: require('../assets/images/googleIconWhite/light/googleIconWhite.png'),
  signInBackground: require('../assets/images/signInBackground/light/signInBackground.png'),
  homeTabActive: require('../assets/images/homeTab/light/homeTabActive.png'),
  chartsTabActive: require('../assets/images/chartsTab/light/chartsTabActive.png'),
  profileTabActive: require('../assets/images/profileTab/light/profileTabActive.png'),
  homeTabInactive: require('../assets/images/homeTab/light/homeTabInactive.png'),
  chartsTabInactive: require('../assets/images/chartsTab/light/chartsTabInactive.png'),
  profileTabInactive: require('../assets/images/profileTab/light/profileTabInactive.png'),
  smallArrowRight: require('../assets/images/modalCalendarImages/light/smallArrowRight/smallArrowRight.png'),
  smallArrowDown: require('../assets/images/modalCalendarImages/light/smallArrowDown/smallArrowDown.png'),
  arrowLeft: require('../assets/images/modalCalendarImages/light/arrowLeft/arrowLeft.png'),
  arrowRight: require('../assets/images/modalCalendarImages/light/arrowRight/arrowRight.png'),
  activeUsers: require('../assets/images/users/active/light/users.png'),
  usualUsers: require('../assets/images/users/usual/light/users.png'),
  activeRightArrow: require('../assets/images/arrows/active/right/light/arrow.png'),
  activeLeftArrow: require('../assets/images/arrows/active/left/light/arrow.png'),
  defaultLeftArrow: require('../assets/images/arrows/default/left/light/arrow.png'),
  defaultRightArrow: require('../assets/images/arrows/default/right/light/arrow.png'),
  disabledLeftArrow: require('../assets/images/arrows/disabled/left/light/arrow.png'),
  disabledRightArrow: require('../assets/images/arrows/disabled/right/light/arrow.png'),
  downArrow: require('../assets/images/arrows/down/light/down.png'),
  participantsMicroOff: require('../assets/images/participantsMicroOff/light/participantsMicroOff.png'),
  participantsVideoOff: require('../assets/images/participantsVideoOff/light/participantsVideoOff.png'),
  appIcon: require('../assets/images/appIcon/light/newAppLogo.png'),
  profilePhoto: require('../assets/images/profilePhoto/light/profilePhoto.png'),
  profilePhotoPurple: require('../assets/images/profilePhoto/light/profilePhotoPurple.png'),
  logout: require('../assets/images/logout/light/logout.png'),
  trash: require('../assets/images/trash/light/red/trash.png'),
  trashDark: require('../assets/images/trash/light/dark/trash.png'),
  googleIconBlue: require('../assets/images/googleIconBlue/light/googleIconBlue.png'),
  pen: require('../assets/images/pen/penPurple/light/pen.png'),
  whitePen: require('../assets/images/pen/penWhite/light/pen.png'),
  grayPen: require('../assets/images/pen/penGray/light/pen.png'),
  error: require('../assets/images/error/light/error.png'),
  cross: require('../assets/images/cross/light/cross.png'),
  crossTransparent: require('../assets/images/crossTransparent/light/crossTransparent.png'),
  success: require('../assets/images/success/light/success.png'),
  symbolHide: require('../assets/images/symbolHide/light/symbolHide.png'),
  symbolShow: require('../assets/images/symbolShow/light/symbolShow.png'),
  dots: require('../assets/images/analytics/dots/light/dots.png'),
  charts: require('../assets/images/analytics/charts/light/charts.png'),
  meatballMenu: require('../assets/images/meatballMenu/light/meatballMenu.png'),
};

export const dark = {
  sent: require('../assets/images/sent/light/sent.png'),
  microOff: require('../assets/images/microOff/light/microOff.png'),
  cameraStateOn: require('../assets/images/camera/on/light/camera.png'),
  cameraStateOff: require('../assets/images/camera/off/light/camera.png'),
  activeChatMessages: require('../assets/images/chatMessages/active/light/chatMessages.png'),
  usualChatMessages: require('../assets/images/chatMessages/usual/light/chatMessages.png'),
  activeFaceSmile: require('../assets/images/faceSmile/active/light/faceSmile.png'),
  usualFaceSmile: require('../assets/images/faceSmile/usual/light/faceSmile.png'),
  microphoneStateOn: require('../assets/images/microphone/on/light/microphone.png'),
  microphoneStateOff: require('../assets/images/microphone/off/light/microphone.png'),
  activeShare: require('../assets/images/activeShare/light/share.png'),
  defaultShare: require('../assets/images/defaultShare/light/share.png'),
  disconnect: require('../assets/images/disconnect/light/disconnect.png'),
  cameraOff: require('../assets/images/cameraOff/light/cameraOff.png'),
  back: require('../assets/images/back/light/back.png'),
  heroImageLoginScreen: require('../assets/images/loginScreenImages/light/heroImage/heroImage.png'),
  leftEllipseGradient: require('../assets/images/loginScreenImages/light/gradientImage/leftEllipseGradient.png'),
  rightEllipseGradient: require('../assets/images/loginScreenImages/light/gradientImage/rightEllipseGradient.png'),
  colorfulGoogleLogo: require('../assets/images/shared/light/googleIcon/colorfulGoogleIcon.png'),
  addIcon: require('../assets/images/createClassScreenImages/light/addImage/add.png'),
  calendarIcon: require('../assets/images/createClassScreenImages/light/calendarImage/calendar.png'),
  classIcon: require('../assets/images/createClassScreenImages/light/classImage/class.png'),
  clockIcon: require('../assets/images/createClassScreenImages/light/clockImage/clock.png'),
  deleteIcon: require('../assets/images/createClassScreenImages/light/deleteImage/delete.png'),
  downArrowIcon: require('../assets/images/createClassScreenImages/light/downImage/down.png'),
  languageIcon: require('../assets/images/createClassScreenImages/light/languageImage/lang.png'),
  subjectIcon: require('../assets/images/createClassScreenImages/light/subjectImage/subject.png'),
  googleIconWhite: require('../assets/images/googleIconWhite/light/googleIconWhite.png'),
  signInBackground: require('../assets/images/signInBackground/light/signInBackground.png'),
  homeTabActive: require('../assets/images/homeTab/light/homeTabActive.png'),
  chartsTabActive: require('../assets/images/chartsTab/light/chartsTabActive.png'),
  profileTabActive: require('../assets/images/profileTab/light/profileTabActive.png'),
  homeTabInactive: require('../assets/images/homeTab/light/homeTabInactive.png'),
  chartsTabInactive: require('../assets/images/chartsTab/light/chartsTabInactive.png'),
  profileTabInactive: require('../assets/images/profileTab/light/profileTabInactive.png'),
  smallArrowRight: require('../assets/images/modalCalendarImages/light/smallArrowRight/smallArrowRight.png'),
  smallArrowDown: require('../assets/images/modalCalendarImages/light/smallArrowDown/smallArrowDown.png'),
  arrowLeft: require('../assets/images/modalCalendarImages/light/arrowLeft/arrowLeft.png'),
  arrowRight: require('../assets/images/modalCalendarImages/light/arrowRight/arrowRight.png'),
  activeUsers: require('../assets/images/users/active/light/users.png'),
  usualUsers: require('../assets/images/users/usual/light/users.png'),
  activeRightArrow: require('../assets/images/arrows/active/right/light/arrow.png'),
  activeLeftArrow: require('../assets/images/arrows/active/left/light/arrow.png'),
  defaultLeftArrow: require('../assets/images/arrows/default/left/light/arrow.png'),
  defaultRightArrow: require('../assets/images/arrows/default/right/light/arrow.png'),
  disabledLeftArrow: require('../assets/images/arrows/disabled/left/light/arrow.png'),
  disabledRightArrow: require('../assets/images/arrows/disabled/right/light/arrow.png'),
  downArrow: require('../assets/images/arrows/down/light/down.png'),
  participantsMicroOff: require('../assets/images/participantsMicroOff/light/participantsMicroOff.png'),
  participantsVideoOff: require('../assets/images/participantsVideoOff/light/participantsVideoOff.png'),
  appIcon: require('../assets/images/appIcon/light/newAppLogo.png'),
  profilePhoto: require('../assets/images/profilePhoto/light/profilePhoto.png'),
  profilePhotoPurple: require('../assets/images/profilePhoto/light/profilePhotoPurple.png'),
  logout: require('../assets/images/logout/light/logout.png'),
  trash: require('../assets/images/trash/light/red/trash.png'),
  trashDark: require('../assets/images/trash/light/dark/trash.png'),
  googleIconBlue: require('../assets/images/googleIconBlue/light/googleIconBlue.png'),
  pen: require('../assets/images/pen/penPurple/light/pen.png'),
  whitePen: require('../assets/images/pen/penWhite/light/pen.png'),
  grayPen: require('../assets/images/pen/penGray/light/pen.png'),
  error: require('../assets/images/error/light/error.png'),
  cross: require('../assets/images/cross/light/cross.png'),
  crossTransparent: require('../assets/images/crossTransparent/light/crossTransparent.png'),
  success: require('../assets/images/success/light/success.png'),
  symbolHide: require('../assets/images/symbolHide/light/symbolHide.png'),
  symbolShow: require('../assets/images/symbolShow/light/symbolShow.png'),
  dots: require('../assets/images/analytics/dots/light/dots.png'),
  charts: require('../assets/images/analytics/charts/light/charts.png'),
  meatballMenu: require('../assets/images/meatballMenu/light/meatballMenu.png'),
};
